export default function WhyPerfectSection({config}) {
    return (
        <div className="max-w-[1110px] mx-auto px-4 py-10 md:py-20">
            <div className="flex flex-col-reverse gap-8 lg:flex-row lg:gap-16 lg:items-center">
                {/* Image */}
                <div className="flex-shrink-0 w-full lg:w-[400px]">
                    <div className="relative">
                        <div className="rounded-[30px] overflow-hidden transform -rotate-[5deg]">
                            <img
                                src={config.image || "/celebs-celebrating.jpg"}
                                alt="Celebrity"
                                className="w-full h-[280px] md:h-[400px] object-cover"
                            />
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                    <h2 className="text-[28px] md:text-[42px] font-bold text-brand-dark leading-[1.1] tracking-[-0.42px] mb-8">
                        {config.title}{' '}
                        <span className="text-gradient">{config.titleHighlight}</span>
                    </h2>

                    <div className="space-y-5 mb-8">
                        {config.reasons.map((reason, idx) => (
                            <div key={idx} className="flex gap-3 items-start">
                                <div
                                    className="w-6 h-6 rounded-md bg-brand-dark flex items-center justify-center flex-shrink-0 mt-0.5">
                                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                                        <path d="M1 5L4.5 8.5L11 1" stroke="white" strokeWidth="2" strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <p className="text-lg font-medium text-brand-dark leading-[1.3] tracking-[-0.18px]">
                                    {reason}
                                </p>
                            </div>
                        ))}
                    </div>

                    {config.blogCta ? (
                        <a
                            href={config.ctaHref || '/'}
                            className="inline-block w-full md:w-auto px-6 py-4 md:px-8 md:py-5 rounded-2xl bg-gradient-to-r from-brand-red via-brand-pink to-brand-orange text-white text-sm font-medium tracking-[-0.14px] hover:opacity-95 transition text-center">
                            {config.ctaText || 'Создать поздравление'}
                        </a>
                    ) : (
                        <button
                            onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
                            className="w-full md:w-auto px-6 py-4 md:px-8 md:py-5 rounded-2xl bg-gradient-to-r from-brand-red via-brand-pink to-brand-orange text-white text-sm font-medium tracking-[-0.14px] hover:opacity-95 transition">
                            {config.ctaText || 'Создать поздравление'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
